// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDNn4dXbiNyY-qWCZ24sB2ng_y215Ajiw0",
  authDomain: "matihaat-d8416.firebaseapp.com",
  projectId: "matihaat-d8416",
  storageBucket: "matihaat-d8416.firebasestorage.app",
  messagingSenderId: "871344636657",
  appId: "1:871344636657:web:552077425c073c373adf50",
  measurementId: "G-R04Y8DVGNR"
};

const firebaseApp = initializeApp(firebaseConfig);
export default firebaseApp;